import { Api } from 'models/services/api';
import { CreateMenuCategoryQuery } from 'models/services/graphql';

import { MenuCategoryData, MenuCategoryDataToCreate } from '../index';

type DataToCreate = {
  businessId: string;
  input: MenuCategoryDataToCreate;
};

const RequestQuery = `
  mutation CreateMenuCategory($businessId: ID!, $input: MenuCategoryCreateInput!) {
    ${CreateMenuCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    createMenuCategory: MenuCategoryData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: MenuCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createMenuCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };